import { render } from "@/components/pages/individualWorkSupport/requirement050/Requirement050.html?vue&type=template&id=185bebba&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement050/Requirement050.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement050/Requirement050.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement050/Requirement050.scss?vue&type=style&index=0&id=185bebba&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185bebba"]])

export default __exports__